import {DialogController} from 'aurelia-dialog';
import {inject} from "aurelia-framework";
import {FormField} from "../../../form/object/form-field";

@inject(
    DialogController
)
export class SelectMediaBundleView {
    constructor(
        dialogController
    ) {
        this.dialogController = dialogController;

        this.bundleField = null;
        this.groupField  = null;
        this.title       = null;
        this.loading     = false;
    }

    async activate(context)
    {
        const dummyFormService = {
            change: () => {}
        };

        this.bundleField = new FormField(
            dummyFormService,
            {
                'type': 'choice',
                'modelId': 'media-database/media-bundle',
                'multiple': false,
                'required': true,
                'label':    'media_database.media-bundle'
            },
            'mediaBundle',
            null
        );

        this.groupField = new FormField(
            dummyFormService,
            {
                'type':     'text',
                'required': false,
                'label':    'media-database.media-bundle.group.label'
            },
            'groupTitle',
            null
        );

        this.title   = context.title;
        this.onSave  = context.onSave;
        this.loading = false;
    }

    async ok()
    {
        this.loading = true;

        return this.onSave({
            bundle: this.bundleField.getValue(),
            group:  this.groupField.getValue()
        }).then(() => {
            return this.dialogController.ok();
        }).catch((error) => {
            this.loading = false;
            throw error;
        });
    }
}
